import { render } from "react-dom";
import React from "react";

export default async function initHeroAnimation() {
   const animationContainer = document.getElementById("supplylp-hero-animation");
   if (animationContainer) {
      const animate = matchMedia("(prefers-reduced-motion)").matches === false;

      if (animate) {
         const moduleExport = await import("./HeroAnimation");
         const HeroAnimation = moduleExport.default;
         render(<HeroAnimation />, animationContainer);
      }
   }
}